<template>
  <section class="section section--contact" id="contact">
    <div class="section__inner">
      <div class="block">
        <a class="pre" href="#contact"> <span>#5</span>Get in touch </a>
        <h2>
          For work inquiries
          <br />please email:
          <br />
          <span>
            <a href="mailto:snowiesuet@gmail.com">snowiesuet@gmail.com</a>
          </span>
        </h2>
        <p class="lead">
          More links:
          <a href="https://github.com/snowiesuet">Github</a>,
          <a href="https://twitter.com/serenites">Twitter</a> and
          <a href="https://www.linkedin.com/in/snowieleung/">Linkedin</a>.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Contact"
};
</script>

<style lang="scss">
.section--contact {
  svg {
    fill: white;
  }
}
</style>
